import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import busyIndicatorActions from './busy-indicator-actions';
import css from './busy-indicator.scss';
import Resources from '../../helpers/resources';

/**
 * BusyIndicator Redux component
 * Displays an overlay on the application and a busy cursor while API requests are
 * being processed
 */
export class BusyIndicator extends Component {
    static propTypes = {
        busyIndicatorCount: PropTypes.number,
        hideBusy: PropTypes.func
    };

    constructor(props) {
        super(props);
        props.hideBusy();
    }

    render() {
        if (this.props.busyIndicatorCount < 1) {
            return null;
        }
        return (
            <div className={css.component} />
        );
    }
}

/**
 * Add Resources interceptors to dispatch busy indicator actions
 * when sending requests and receiving responses
 */
function addInterceptors(dispatch) {
    const env = Resources.env;

    function requestInterceptor() {
        dispatch(busyIndicatorActions.showBusy());
    }

    function responseInterceptor(response) {
        if (!env.havePendingRequests()) {
            dispatch(busyIndicatorActions.hideBusy());
        }

        return response;
    }

    env.addRequestInterceptor(requestInterceptor);
    env.addResponseInterceptor(responseInterceptor);
}

/*
 * mapStateToProps - set component properties from current state provided by the Reducers.
 * @param state {object} - the revised state from CombinedReducers.
 */
function mapStateToProps(state) {
    return {
        busyIndicatorCount: state.busyIndicatorCount
    };
}

/*
 * mapDispatchToProps - ensure that the outputs of the Action Creators are passed to the Reducers
 * @param dispatch
 */
function mapDispatchToProps(dispatch) {
    addInterceptors(dispatch);

    return bindActionCreators({
        hideBusy: busyIndicatorActions.hideBusy,
        showBusy: busyIndicatorActions.showBusy
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(styleable(css)(BusyIndicator));



// WEBPACK FOOTER //
// ./components/busy-indicator/busy-indicator.js